import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <div className="ax-brand-card">
      <Link
        to={`/brands/${item?.slug || item?.slugPath}`}
        className="ax-brand-link"
      >
        <div className="ax-brand-image">
          {item?.image && (
            <img src={item.image} alt={item.name} />
          )}
        </div>

        <div className="ax-brand-content">
          {/* <span>{item?.name}</span> */}
        </div>
      </Link>
    </div>
  );
}

export default Card;